import template from './template.html';
import controller from './controller';

export default {
  url: '/:id',
  stateName: 'View Bundle',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app': {
      template,
      controller
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/controllers/marketplace/bundle/index.js